export type LiveMediaMode = 'original' | 'character';
export type MediaLiveKind = 'audio' | 'video';
export type { LiveVoicePreset } from './audio/voicePresets';
export type { LiveAvatarPreset } from './avatar/avatarPresets';

export const LIVE_MEDIA_PIPELINE_VERSION = 1;

export const isLiveMediaMode = (value: unknown): value is LiveMediaMode =>
  value === 'original' || value === 'character';

export const isMediaLiveKind = (value: unknown): value is MediaLiveKind =>
  value === 'audio' || value === 'video';
